export default __webpack_public_path__ + "static/media/add-icon.431dd623.svg";